import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import {
  Card,
  CardBody,
  Col,
  Collapse,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import "../../assets/scss/components/LandingPage/index.scss";

import { Bar, Pie } from "react-chartjs-2";
import {
  fetchBarGraphStatistics,
  fetchCustomerStatistics,
  fetchEventsStatistics,
  fetchPieChartStatistics,
  fetchRidesStatistics,
} from "../../redux/Statistics/actions";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/scss/components/CustomDatepicker/index.scss";
import { calendar } from "react-icons-kit/fa/calendar";
import get from "lodash/get";
import moment from "moment";
import history from "../../history";
import CustomButton from "../CustomButton";
import InputText from "../InputText";
import CustomDatepicker from "../CustomDatepicker";
import { toast } from "react-toastify";
import CartTitle from "../CartTitle";
import {
  deleteExperienceInfo,
  fetchExperienceDetail,
  fetchExperiencesList,
} from "../../redux/moderation/experience/actions";
import {
  deleteTourInfo,
  fetchToursDetail,
  fetchToursList,
} from "../../redux/moderation/tours/actions";
import {
  deleteTestimonial,
  fetchTestimonialDetails,
  fetchTestimonialList,
} from "../../redux/Testimonials/action";
import TourDetails from "../TourDetails";
import ExperienceDetails from "../ExperienceDetail";
import TestimonialDetails from "../TestimonialDetails";
import PartnerPersonalForm from "../PartnerPersonalForm";
import {
  deletePartnerInfo,
  partnerForm,
  clearingPreviousReducer,
  fetchPartnersDetails,
  fetchPartnersList,
  fetchingPieChartStatistics,
} from "../../redux/partners/actions";
import {
  uploadGalleryUrl,
  uploadUrl,
  uploadVideoUrl,
} from "../../redux/uploadImage/action";
import {
  fetchingCountriesJson,
  fetchingRegionJson,
} from "../../redux/Global/actions";
import {
  fetchMotorCylce,
  fetchUserCountryMobileCode,
} from "../../redux/user/actions";
import PartnerDetails from "../PartnerDetails";
import Loader from "../Loader";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//  } from 'chart.js';

// const _ = { get };
// ChartJS.register(
//   ArcElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
//  );
const AdminJourneyPage = () => {
  const dispatch = useDispatch();
  const { pieChartStatistics } = useSelector((state) => state.Partner);
  const { elements } = useSelector((state) => state.Elements);
  const { countries, regionJson, tourCountriesJson } = useSelector(
    (state) => state.Global
  );
  const {
    toursList,
    toursListCount,
    toursDetails,
    tourLoading,
    toursPendingCount,
  } = useSelector((state) => state.Tours);
  const { countryMobileCode } = useSelector((state) => state.User);
  const {
    experienceList,
    experienceListCount,
    experienceDetails,
    experienceLoading,
    experiencePendingCount,
  } = useSelector((state) => state.Experience);

  const {
    partnersList,
    partnersListCount,
    partnerDetailsData,
    partnersPendingCount,
  } = useSelector((state) => state.Partner);

  const _ = { get };
  const {
    testimonialsList,
    testimonialsListCount,
    testimonialsDetailsData,
    testimonialLoading,
    testimonialsPendingCount,
  } = useSelector((state) => state.Testimonials);

  const { accessibleCountries } = useSelector(
    (state) => state.Auth.userProfile
  );

  const { usertype, userProfile } = useSelector((state) => state.Auth);

  const [yearlyEvents, setYearlyEvents] = useState(null);
  const [yearlyEventPaticipants, setYearlyEventPaticipants] = useState(null);
  const [yearlyRides, setYearlyRides] = useState(null);
  const [yearlyRideParticipants, setYearlyRideParticipants] = useState(null);
  const [toggleActive, setToggleActive] = useState(true);
  const [toggleCollapse, setToggleCollapse] = useState(false);
  const [country, setCountry] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [category, setCategory] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [parsedCountry, setParsedCountry] = useState("");
  const [tourDetails, setTourDetails] = useState(false);
  const [toursDetailsId, setTourDetailsId] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [experienceDetail, setExperienceDetails] = useState(false);
  const [experienceDetailsId, setExperienceDetailsId] = useState("");
  const [testimonialDetail, setTestimonialDetails] = useState(false);
  const [testimonialDetailId, setTestimonialDetailsId] = useState(false);
  const [partnerAddModel, setPartnerAddModel] = useState(false);
  const [partnerId, setPartnerId] = useState("");
  const [toggleRejectModal, setToggleRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [state, setState] = useState("");
  const { motorCycle } = useSelector((state) => state.User);
  const handleGetDetails = () => {
    if (toursDetailsId) {
      dispatch(fetchToursDetail(toursDetailsId));
    } else {
      dispatch(fetchExperienceDetail(experienceDetailsId));
    }
  };

  const handleFetchPartnerDetails = () => {
    dispatch(fetchPartnersDetails(partnerId));
  };

  const handleDetails = () => {
    dispatch(fetchTestimonialDetails(testimonialDetailId));
  };

  const handleCallBack = () => {
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: "TOUR",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: "EXPERIENCE",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          country: country,
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
  };
  // const branchesData = {
  //   labels: [
  //     _.get(elements, "landingPageElement.approvedPieElement", "Approved"),
  //     _.get(elements, "landingPageElement.rejectedPieElement", "Rejected"),
  //     _.get(elements, "landingPageElement.pendingPieElement", "Pending"),
  //   ],
  //   datasets: [
  //     {
  //       label: "Branches",
  //       data: pieChartStatistics
  //         ? [
  //             pieChartStatistics.branches.branchApprovedCount,
  //             pieChartStatistics.branches.branchRejectedCount,
  //             pieChartStatistics.branches.branchPendingCount,
  //           ]
  //         : [0, 0, 0],
  //       fill: true,
  //       backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
  //       backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
  //       hoverBackgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
  //     },

  //   ],
  // };

  const handleFetchPartnersList = (payload) => {
    dispatch(fetchPartnersList(payload));
  };

  const handleCreatePartner = (data) => {
    dispatch(partnerForm(data, handlepartnerCallBack));
  };

  const handlepartnerCallBack = () => {
    setPartnerAddModel(!partnerAddModel);
  };

  const partnersData = {
    labels: [
      "Pending",
      "Approved",
      "Rejected",
      // `Pending (${pieChartStatistics && pieChartStatistics.pending})`,
      // `Approved (${pieChartStatistics && pieChartStatistics.approved})`,
      // `Rejected (${pieChartStatistics && pieChartStatistics.rejected})`,
    ],
    datasets: [
      {
        label: ["Pending", "Approved", "Rejected"],
        data: pieChartStatistics
          ? [
              pieChartStatistics.pending,
              pieChartStatistics.approved,
              pieChartStatistics.rejected,
            ]
          : [0, 0, 0],
        fill: true,
        backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
        backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
        hoverBackgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
      },
    ],
  };
  // const options = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //     display: true,
  //     text: "Chart.js Line Chart",
  //     position: 'right',
  //     // labels: {
  //     // fontSize: 20,
  //     // color: 'white',
  //     // usePointStyle: true,
  //     // pointStyle: 'circle',
  //     // padding: 15,
  //     // },
  //     },
  //     },
  //   // plugins: {
  //   //   title: {
  //   //     display: true,
  //   //     text: "Chart.js Line Chart",
  //   //   },
  //   // },
  // };

  const yearlyParticipants = (data, setYearlyData, selectionString) => {
    if (data) {
      const yearlyEventParticipants = [];
      data.forEach((element) => {
        if (element._id) {
          if (
            yearlyEventParticipants &&
            yearlyEventParticipants.length === 12
          ) {
            yearlyEventParticipants[element._id.month - 1] =
              element[selectionString];
          } else {
            for (let i = 1; i <= 12; i++) {
              if (element._id.month === i) {
                yearlyEventParticipants.push(element[selectionString]);
              } else {
                if (yearlyEventParticipants) {
                  yearlyEventParticipants.push(0);
                } else {
                  yearlyEventParticipants = [0];
                }
              }
            }
          }
        }
      });
      console.log("yearly", yearlyEventParticipants);
      setYearlyData(yearlyEventParticipants);
    }
  };

  const handleToggle = (e) => {
    setToggleActive(!toggleActive);
    if (toggleCollapse === true) {
      setToggleCollapse(!toggleCollapse);
    }
  };

  const handleSearch = () => {
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: "TOUR",
          status: "",
          country: country,
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: "EXPERIENCE",
          status: "",
          country: country,
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    // }
    // if (category == "TOUR") {
    //   dispatch(
    //     fetchToursList(
    //       {
    //         page: 0,
    //         limit: 100,
    //         category: category,
    //         status: "",
    //         country: country,
    //         startDate:
    //           startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
    //         endDate:
    //           endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
    //       },
    //       "overview"
    //     )
    //   );
    // } else if (category == "EXPERIENCE") {
    //   dispatch(
    //     fetchExperiencesList(
    //       {
    //         page: 0,
    //         limit: 100,
    //         category: category,
    //         country: country,
    //         status: "",
    //         startDate:
    //           startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
    //         endDate:
    //           endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
    //       },
    //       "overview"
    //     )
    //   );
    // }
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          country: country,
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
    // dispatch(
    //   fetchPartnersList(
    //     {
    //       page: 0,
    //       limit: 100,
    //       country: country,
    //       email: "",
    //       phone: "",
    //     },
    //     "overview"
    //   )
    // );
  };

  const handleClearFilter = () => {
    setStartDate("");
    setEndDate("");
    setCountry("");
    setCategory("");
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: "TOUR",
          country: "",
          status: "",
          startDate: null,
          endDate: null,
        },
        "overview"
      )
    );
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: "EXPERIENCE",
          country: "",
          status: "",
          startDate: null,
          endDate: null,
        },
        "overview"
      )
    );
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          startDate: "",
          endDate: "",
          country: "",
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
  };

  const handleCountryChange = (e) => {
    if (e.target.value !== "") {
      setCountry(e.target.value);
      let countryCode = tourCountriesJson.filter((item) => {
        if (item.country === e.target.value) {
          return item.locality.country;
        }
      })[0].locality.country;
      setCountryCode(countryCode);
    } else {
      setCountry("");
    }
  };

  const handleOnChange = (e) => {
    setRejectionReason(e.target.value);
  };
  const handleRejectModal = () => {
    setToggleRejectModal(!toggleRejectModal);
  };

  const handleDeleteCallBack = () => {
    handleRejectModal();
    setPartnerAddModel(!partnerAddModel);
    let obj = {
      page: 0,
      limit: 100,
      country: "",
      email: "",
      phone: "",
    };
    setRejectionReason("");
    dispatch(fetchPartnersList(obj, "overview"));
  };

  const handleGoBack = () => {
    handleRejectModal();
    setTestimonialDetails(!testimonialDetail);
    setRejectionReason("");
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          country: country,
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
  };

  const handleGoBackTour = () => {
    handleRejectModal();
    setTourDetails(!tourDetails);
    setRejectionReason("");
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: "TOUR",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
  };

  const handleGoBackExpeirence = () => {
    handleRejectModal();
    setExperienceDetails(!experienceDetails);
    setRejectionReason("");
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: "EXPERIENCE",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
  };

  const handleDelete = () => {
    if (state === "partner") {
      let obj = {
        partnerId: partnerId,
        status: "DELETED",
        rejectionReason: rejectionReason,
      };
      dispatch(deletePartnerInfo(obj, handleDeleteCallBack));
    } else if (state === "tour") {
      let obj = {
        wanderlustId: toursDetailsId,
        status: "DELETED",
        rejectionReason: state.rejectionReason,
      };
      dispatch(deleteTourInfo(obj, handleGoBackTour));
    } else if (state === "experience") {
      let obj = {
        wanderlustId: experienceDetailsId,
        status: "DELETED",
        rejectionReason: state.rejectionReason,
      };
      dispatch(deleteExperienceInfo(obj, handleGoBackExpeirence));
    } else {
      let obj = {
        testimonialId: testimonialDetailId,
        status: "DELETED",
        rejectionReason: state.rejectionReason,
      };
      dispatch(deleteTestimonial(obj, handleGoBack));
    }
  };

  useEffect(() => {
    if (usertype === "EU Tours Admin" || usertype === "Admin") {
      dispatch(fetchingRegionJson());
      dispatch(fetchUserCountryMobileCode());
      dispatch(fetchingPieChartStatistics());
      dispatch(fetchMotorCylce("uk"));
    }
    dispatch(fetchingCountriesJson());
  }, []);
  // useEffect(() => {
  //   let newStartDate = new Date().setFullYear(new Date().getFullYear(), 0, 1);
  //   let newEndDate = new Date().setFullYear(new Date().getFullYear(), 11, 31);
  //   setStartDate(newStartDate);
  //   setEndDate(newEndDate);
  //   let obj = {
  //     startDate: newStartDate ? moment(newStartDate).format("DD/MM/YYYY") : "",
  //     endDate: newEndDate ? moment(newEndDate).format("DD/MM/YYYY") : "",
  //     country: countryCode,
  //   };
  //   dispatch(fetchPieChartStatistics(obj));
  //   dispatch(fetchCustomerStatistics(obj));
  //   dispatch(fetchEventsStatistics(obj));
  //   dispatch(fetchRidesStatistics(obj));
  // }, []);

  useEffect(() => {
    if (
      accessibleCountries &&
      tourCountriesJson &&
      tourCountriesJson.length !== 0
    ) {
      if (accessibleCountries.length === 1 && accessibleCountries[0] === "*") {
        setCountryList(tourCountriesJson);
      } else if (
        accessibleCountries.length === 1 &&
        accessibleCountries[0] !== "*"
      ) {
        let newCountry = tourCountriesJson.filter((data) =>
          accessibleCountries.includes(data.locality.country)
        );
        setCountryList(newCountry);
      } else {
        setCountryList(
          tourCountriesJson.filter((data) =>
            accessibleCountries.includes(data.locality.country)
          )
        );
      }
    }
  }, [accessibleCountries, tourCountriesJson]);

  useEffect(() => {
    // if (category === "") {
    dispatch(
      fetchToursList(
        {
          page: 0,
          limit: 100,
          category: "TOUR",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    dispatch(
      fetchExperiencesList(
        {
          page: 0,
          limit: 100,
          category: "EXPERIENCE",
          country: country,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
        },
        "overview"
      )
    );
    // }
    // if (category == "TOUR") {
    //   dispatch(
    //     fetchToursList(
    //       {
    //         page: 0,
    //         limit: 100,
    //         category: category,
    //         country: country,
    //         status: "",
    //         startDate:
    //           startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
    //         endDate:
    //           endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
    //       },
    //       "ovrview"
    //     )
    //   );
    // } else if (category == "EXPERIENCE") {
    //   dispatch(
    //     fetchExperiencesList(
    //       {
    //         page: 0,
    //         limit: 100,
    //         category: category,
    //         status: "",
    //         ountry: country,
    //         startDate:
    //           startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
    //         endDate:
    //           endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
    //       },
    //       "overview"
    //     )
    //   );

    // }
    dispatch(
      fetchPartnersList(
        {
          page: 0,
          limit: 100,
          country: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
    dispatch(
      fetchTestimonialList(
        {
          page: 0,
          limit: 100,
          status: "",
          startDate:
            startDate !== "" ? moment(startDate).format("DD-MM-YYYY") : null,
          endDate: endDate !== "" ? moment(endDate).format("DD-MM-YYYY") : null,
          country: country,
          state: "",
          city: "",
          email: "",
          phone: "",
        },
        "overview"
      )
    );
  }, []);

  return (
    <>
      {console.log("data", toursDetailsId)}
      <div className="mt-4 px-3 pb-3">
        {tourLoading && experienceLoading && testimonialLoading && <Loader />}
        <Row>
          <Col sm={12}>
            <CartTitle
              title={`${_.get(
                elements,
                "euToursElement.AdminLandingPage.welcomeText",
                "Welcome"
              )} ${userProfile.fName} ${userProfile.lName}`}
              Name={_.get(
                elements,
                "euToursElement.AdminLandingPage.filterButtonElement",
                "Filter"
              )}
              iconClass={"hideexcel"}
              handleToggle={() => handleToggle()}
            />
          </Col>
          <Col sm={12}>
            <Collapse isOpen={toggleActive}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col xl={3} lg={3} md={6} sm={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.AdminLandingPage.selectCategoryElement",
                          "Select Category"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.AdminLandingPage.selectCategoryPlaceholderElement",
                              "Select Category"
                            )}
                          </option>
                          <option value="TOUR">
                            {_.get(
                              elements,
                              "euToursElement.AdminLandingPage.tourCategoryOptionElement",
                              "Tours"
                            )}
                          </option>
                          <option value="EXPERIENCE">
                            {_.get(
                              elements,
                              "euToursElement.AdminLandingPage.experienceCategoryOptionElement",
                              "Experience"
                            )}
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xl={3} lg={3} md={6} sm={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.AdminLandingPage.selectCountryElement",
                          "Select Country"
                        )}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="country"
                          className="w-100 customeSelectBtn"
                          value={country}
                          onChange={(e) => handleCountryChange(e)}
                        >
                          <option value="">
                            {_.get(
                              elements,
                              "euToursElement.AdminLandingPage.countryLabel",
                              "All Countries"
                            )}
                          </option>
                          {tourCountriesJson &&
                            tourCountriesJson.length > 0 &&
                            tourCountriesJson
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option key={index} value={item.country}>
                                  {item.country}
                                </option>
                              ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg={3} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.AdminLandingPage.startDateLabelElement",
                          "Start Date"
                        )}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={startDate}
                          customPlaceHolder={_.get(
                            elements,
                            "euToursElement.AdminLandingPage.startDatePlaceHolderElement",
                            "Select Start Date"
                          )}
                          handleDateChange={(startDate) =>
                            setStartDate(startDate)
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={3} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "euToursElement.AdminLandingPage.endDateLabelElement",
                          "End Date"
                        )}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={endDate}
                          customPlaceHolder={_.get(
                            elements,
                            "euToursElement.AdminLandingPage.endDatePlaceHolderElement",
                            "Select End Date"
                          )}
                          handleDateChange={(endDate) => setEndDate(endDate)}
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={startDate}
                          customDisable={startDate === ""}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-flex mt-3">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.AdminLandingPage.searchButtonElement",
                            "Search"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => handleSearch()}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "euToursElement.AdminLandingPage.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => handleClearFilter()}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
          </Col>
        </Row>

        <Row>
          <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
            <div className="white-box shadow whitebox_Height position-relative table_box">
              <div className="d-flex justify-content-between">
                <h5 className="pie_heading font-weight-bold table_box_heading">
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.partnerElement",
                    "Partners"
                  )}{" "}
                  ({partnersListCount})
                </h5>
                <button
                  className="pending_button pending_button_heading"
                  onClick={() => history.push("/partner/list")}
                >
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.viewPendingRequestElement",
                    "View Pending Request"
                  )}{" "}
                  ({partnersPendingCount})
                </button>
              </div>
              <div className="scrollable_details admin_scroll_height">
                {partnersList && partnersList.length > 0 ? (
                  <table className="table_partner">
                    <thead>
                      <tr className="table_row">
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.partnerNameLabel",
                            "Partner Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.statusLabel",
                            "Status"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.actionLabel",
                            "Action"
                          )}
                        </th>
                      </tr>
                    </thead>
                    {partnersList &&
                      partnersList.map((item) => (
                        <tbody>
                          <tr className="table_row">
                            <td className="table_value table_line">
                              {item && item.name}
                            </td>
                            <td className="table_value table_line">
                              {item && item.moderationStatus}
                            </td>
                            <td
                              className="view_details table_line"
                              // onClick={() => {
                              //   setTourDetails(!tourDetails);
                              //   setTourDetailsId(item._id);
                              // }}
                              onClick={() => {
                                setPartnerId(item._id);
                                setPartnerAddModel(!partnerAddModel);
                                setState("partner");
                              }}
                            >
                              {_.get(
                                elements,
                                "euToursElement.AdminLandingPage.viewDetailButtonElement",
                                "View detail"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                ) : (
                  <div className="nodata_Text">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.AdminLandingPage.noDataToShowElement",
                        "No data to show"
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
            <div className="white-box shadow whitebox_Height position-relative table_box">
              <div className="d-flex justify-content-between">
                <h5 className="pie_heading font-weight-bold table_box_heading">
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.pendingTourApprovalElement",
                    "Tours"
                  )}{" "}
                  ({category === "TOUR" || category === "" ? toursListCount : 0}
                  )
                </h5>
                <button
                  className="pending_button pending_button_heading"
                  onClick={() => history.push("/moderation/tours")}
                >
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.viewPendingRequestElement",
                    "View Pending Request"
                  )}{" "}
                  ({toursPendingCount})
                </button>
              </div>
              <div className="scrollable_details admin_scroll_height">
                {(category === "TOUR" || category === "") &&
                toursList &&
                toursList.length > 0 ? (
                  <table className="table_partner">
                    <thead>
                      <tr className="table_row">
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.nameLabel",
                            "Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.partnerNameLabel",
                            "Partner Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.statusLabel",
                            "Status"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.actionLabel",
                            "Action"
                          )}
                        </th>
                      </tr>
                    </thead>
                    {toursList &&
                      toursList.map((item) => (
                        <tbody>
                          <tr className="table_row">
                            <td className="table_value table_line">
                              {item && item.name}
                            </td>
                            <td className="table_value table_line">
                              {item && item.partnerId && item.partnerId.name}
                            </td>
                            <td className="table_value table_line">
                              {item && item.moderationStatus}
                            </td>
                            <td
                              className="view_details table_line"
                              onClick={() => {
                                setTourDetails(!tourDetails);
                                setTourDetailsId(item._id);
                                setState("tour");
                              }}
                            >
                              {_.get(
                                elements,
                                "euToursElement.AdminLandingPage.viewDetailButtonElement",
                                "View detail"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                ) : (
                  <div className="nodata_Text">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.AdminLandingPage.noDataToShowElement",
                        "No data to show"
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
            <div className="white-box shadow whitebox_Height position-relative table_box">
              <div className="d-flex justify-content-between">
                <h5 className="pie_heading font-weight-bold table_box_heading">
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.pendingExperienceApproval",
                    "Experience"
                  )}{" "}
                  (
                  {category !== "TOUR" || category === ""
                    ? experienceListCount
                    : 0}
                  )
                </h5>
                <button
                  className="pending_button pending_button_heading"
                  onClick={() => history.push("/moderation/experiences")}
                >
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.viewPendingRequestElement",
                    "View Pending Request"
                  )}{" "}
                  ({experiencePendingCount})
                </button>
              </div>
              <div className="scrollable_details admin_scroll_height">
                {(category !== "TOUR" || category === "") &&
                experienceList &&
                experienceList.length > 0 ? (
                  <table className="table_partner">
                    <thead>
                      <tr className="table_row">
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.nameLabel",
                            "Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.partnerNameLabel",
                            "Partner Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.statusLabel",
                            "Status"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.AdminLandingPage.actionLabel",
                            "Action"
                          )}
                        </th>
                      </tr>
                    </thead>
                    {experienceList &&
                      experienceList.map((item) => (
                        <tbody>
                          <tr className="table_row">
                            <td className="table_value table_line">
                              {item && item.name}
                            </td>
                            <td className="table_value table_line">
                              {item && item.partnerId && item.partnerId.name}
                            </td>
                            <td className="table_value table_line">
                              {item && item.moderationStatus}
                            </td>
                            <td
                              className="view_details table_line"
                              onClick={() => {
                                setExperienceDetails(!experienceDetail);
                                setExperienceDetailsId(item._id);
                                setState("experience");
                              }}
                            >
                              {_.get(
                                elements,
                                "euToursElement.AdminLandingPage.viewDetailButtonElement",
                                "View detail"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                ) : (
                  <div className="nodata_Text">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.AdminLandingPage.noDataToShowElement",
                        "No data to show"
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
            <div className="white-box shadow whitebox_Height position-relative  ">
              <div className="d-flex justify-content-between">
                <h5 className="pie_heading font-weight-bold mb-4">
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.pendingTestimonialsElement",
                    "Testimonials"
                  )}{" "}
                  ({testimonialsListCount ? testimonialsListCount : 0})
                </h5>
                <button
                  className="pending_button"
                  onClick={() => history.push("/moderation/testimonials")}
                >
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.viewPendingRequestElement",
                    "View Pending Request"
                  )}{" "}
                  ({testimonialsPendingCount})
                </button>
              </div>
              <div className="scrollable_details admin_scroll_height">
                {testimonialsList && testimonialsList.length > 0 ? (
                  <table className="table_partner">
                    <thead>
                      <tr className="table_row">
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.nameLabel",
                            "Name"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.nameLabel",
                            "Description"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.statusLabel",
                            "Status"
                          )}
                        </th>
                        <th className="table_heading">
                          {_.get(
                            elements,
                            "euToursElement.partnerLandingPage.actionLabel",
                            "Action"
                          )}
                        </th>
                      </tr>
                    </thead>
                    {testimonialsList &&
                      testimonialsList.map((item) => (
                        <tbody>
                          <tr className="table_row">
                            <td className="table_value table_line">
                              {item && item.author}
                            </td>
                            <td className="table_value table_line">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description.replace(
                                    /(.{10})..+/,
                                    "$1…"
                                  ),
                                }}
                              />
                            </td>
                            <td className="table_value table_line">
                              {item && item.moderationStatus}
                            </td>
                            <td
                              className="view_details table_line"
                              onClick={() => {
                                setTestimonialDetails(!testimonialDetail);
                                setTestimonialDetailsId(item._id);
                                setState("testimonials");
                              }}
                            >
                              {_.get(
                                elements,
                                "euToursElement.partnerLandingPage.viewDetailButtonElement",
                                "View detail"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                ) : (
                  <div className="nodata_Text">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.partnerLandingPage.noDataToShowElement",
                        "No data to show"
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Col>

          {/* {pieChartStatistics ? (
            <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height">
                <div className="d-flex justify-content-between">
                  <h5 className="pie_heading font-weight-bold">
                    {_.get(
                      elements,
                      "euToursElement.AdminLandingPage.partnerElement",
                      "Partners"
                    )}
                  </h5>
                  <button
                    className="add_button btn-outline-dark bg-none btnthemeColor"
                    onClick={() => setPartnerAddModel(!partnerAddModel)}
                  >
                    {_.get(
                      elements,
                      "euToursElement.AdminLandingPage.addPartnerElement",
                      "Add Partner"
                    )}
                  </button>
                </div>
                <Pie data={partnersData} width={100} height={50} />
                <div className="text-right">
                  <button
                    className="pending_button"
                    onClick={() => history.push("/partner/list")}
                  >
                    {_.get(
                      elements,
                      "euToursElement.AdminLandingPage.viewPendingRequestElement",
                      "View Pending Request"
                    )}
                  </button>
                </div>
              </div>
            </Col>
          ) : (
            <Col xl={6} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height position-relative">
                <h5 className="pie_heading">
                  {_.get(
                    elements,
                    "euToursElement.AdminLandingPage.partnerElement",
                    "Partners"
                  )}
                </h5>
                <div className="nodata_Text">
                  <span>
                    {_.get(
                      elements,
                      "euToursElement.AdminLandingPage.noDataToShowElement",
                      "No data to show"
                    )}
                  </span>
                </div>
              </div>
            </Col>
          )} */}
        </Row>
        <Modal
          isOpen={tourDetails}
          toggle={() => setTourDetails(!tourDetails)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <TourDetails
              selectedId={toursDetailsId}
              handleBackCall={handleCallBack}
              tourDetails={toursDetails}
              handleGetDetails={() => handleGetDetails()}
              handleToggleModel={() => setTourDetails(!tourDetails)}
              handleRejectModal={handleRejectModal}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={experienceDetail}
          toggle={() => setExperienceDetails(!experienceDetail)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <ExperienceDetails
              selectedId={experienceDetailsId}
              handleBackCall={handleCallBack}
              tourDetails={experienceDetails}
              handleGetDetails={() => handleGetDetails()}
              handleToggleModel={() => setExperienceDetails(!experienceDetail)}
              handleRejectModal={handleRejectModal}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={testimonialDetail}
          toggle={() => setTestimonialDetails(!testimonialDetail)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <TestimonialDetails
              selectedId={testimonialDetailId}
              testimonialsDetailsData={testimonialsDetailsData}
              handleBackCall={handleCallBack}
              handleFetchTestimonialDetails={() => handleDetails()}
              handleToggleModel={() =>
                setTestimonialDetails(!testimonialDetail)
              }
              handleRejectModal={handleRejectModal}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={partnerAddModel}
          toggle={() => setPartnerAddModel(!partnerAddModel)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            {/* <PartnerPersonalForm
              handleToggleModel={() => setPartnerAddModel(!partnerAddModel)}
              countryList={tourCountriesJson}
              countryMobileCode={countryMobileCode}
              handleCreatePartner={handleCreatePartner}
              usertype={usertype}
              fetchList={handleFetchPartnersList}
              motorCycle={motorCycle}
              uploadUrl={() => dispatch(uploadUrl())}
              clearingPreviousReducer={() =>
                dispatch(clearingPreviousReducer())
              }
              uploadGalleryUrl={() => dispatch(uploadGalleryUrl())}
              uploadVideoUrl={() => dispatch(uploadVideoUrl())}
              regionJson={regionJson}
            /> */}
            <PartnerDetails
              selectedId={partnerId}
              partnerDetailsData={partnerDetailsData}
              handleFetchPartnerDetails={handleFetchPartnerDetails}
              handleToggleModel={() => setPartnerAddModel(!partnerAddModel)}
              handleRejectModal={handleRejectModal}
              elements={elements}
              component={"overview"}
            />
          </ModalBody>
        </Modal>
        <Modal isOpen={toggleRejectModal} backdrop={true} centered={true}>
          <ModalHeader toggle={handleRejectModal}>
            {_.get(
              elements,
              "euToursElement.partnerListElement.rejectionModelLabel",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={rejectionReason}
              customOnChange={(e) => handleOnChange(e)}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "euToursElement.partnerListElement.rejectModelButtonElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => handleDelete(e)}
            />
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default AdminJourneyPage;
